import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const SalesQuote = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section
      className="relative bg-black py-20 md:py-28 overflow-hidden"
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      {/* Large Glow */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[800px] h-[400px] bg-[#00FFD1]/8 rounded-full blur-[150px]" />
      </div>

      {/* Grid Lines */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)
          `,
          backgroundSize: '100px 100px',
        }}
      />

      <div className="relative max-w-[1000px] mx-auto px-5 md:px-[7.6923%] text-center">
        {/* Quote Mark */}
        <div className="text-[#00FFD1]/20 text-[150px] md:text-[200px] font-serif leading-none absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/4 select-none">
          "
        </div>

        <div className="relative space-y-6">
          <p className="text-3xl md:text-4xl lg:text-[48px] font-semibold text-white leading-[1.2] tracking-[-0.02em]">
            {t('quote.line1')}
          </p>
          <p className="text-2xl md:text-3xl lg:text-[36px] font-medium text-[#00FFD1] leading-[1.3]">
            {t('quote.line2')}
          </p>
          <p className="text-xl md:text-2xl text-white/60 leading-relaxed max-w-2xl mx-auto pt-4">
            {t('quote.line3')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SalesQuote;
